import { render, staticRenderFns } from "./RemoveOrderFromTruckModal.vue?vue&type=template&id=dee0ba7e"
import script from "./RemoveOrderFromTruckModal.vue?vue&type=script&lang=js"
export * from "./RemoveOrderFromTruckModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports